import styled from 'styled-components';
import {Button} from "@mui/material";

export const StyledSecondaryActionButton = styled(Button)`
    && {
        display: flex;
        align-items: center;
        flex-shrink: 0;
        gap: 6px;
        
        @media (max-width: 399px) {
            width: 100%;
        }
    }
`;